import * as React from "react"
import { Admin, Resource, DeleteButton } from 'react-admin'
import dataProvider from './dataProvider'
import authProvider from './authProvider';
import Dashboard from './Dashboard'

import { MatchList, MatchShow, MatchIcon } from './resources/matchs'
import { MatchTerrainList, MatchTerrainShow, MatchTerrainEdit, MatchTerrainCreate, MatchTerrainIcon } from './resources/matchterrains'
import { ConfigList, ConfigShow, ConfigEdit, ConfigIcon } from './resources/configs'
import { ArchivematchList, ArchivematchShow, ArchivematchIcon } from './resources/archivematchs'
import { ScrapperRequestList, ScrapperRequestIcon } from './resources/scrapperrequests'
import { VolleyMatchList, VolleyMatchIcon } from './resources/volleymatchs'
import { VolleyRankingList, VolleyRankingIcon } from './resources/volleyrankings'
import { ImageResourceList, ImageResourceCreate, ImageResourceIcon } from './resources/images'
import { VolleyClubList, VolleyClubEdit, VolleyClubIcon } from './resources/volleyclubs'

const App = () => (
  <Admin
    dataProvider={dataProvider}
    authProvider={authProvider}
    // dashboard={Dashboard}
  >
    <Resource name="Match" list={MatchList} show={MatchShow} icon={MatchIcon} />
    <Resource name="MatchTerrain" list={MatchTerrainList} show={MatchTerrainShow} edit={MatchTerrainEdit} create={MatchTerrainCreate} icon={MatchTerrainIcon} />
    {/* <Resource name="Config" list={ConfigList} show={ConfigShow} edit={ConfigEdit} icon={ConfigIcon} /> */}
    {/* <Resource name="Archivematch" list={ArchivematchList} show={ArchivematchShow} icon={ArchivematchIcon} /> */}
    {/* <Resource name="ScrapperRequestsFails" list={ScrapperRequestList} icon={ScrapperRequestIcon} /> */}
    <Resource name="VolleyMatch" list={VolleyMatchList} icon={VolleyMatchIcon} />
    <Resource name="VolleyRanking" list={VolleyRankingList} icon={VolleyRankingIcon} />
    {/* <Resource name="Image" list={ImageResourceList} create={ImageResourceCreate} icon={ImageResourceIcon} /> */}
    <Resource name="VolleyClub" list={VolleyClubList} edit={VolleyClubEdit} icon={VolleyClubIcon} />
  </Admin>
)

export default App
